var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessPackagesBoxSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "packages-box-svgrepo-com 1",
    clipPath: "url(#clip0_2728_34159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5859 31.0355C48.7289 31.0355 49.6548 31.9614 49.6548 33.1044V35.1734H55.8618V18.6217C55.8618 17.4786 54.9359 16.5527 53.7929 16.5527H33.1031C31.9601 16.5527 31.0342 17.4786 31.0342 18.6217V31.0355H47.5859Z",
    fill: "#CB8252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.7591 26.8968C23.9022 26.8968 24.8281 27.8227 24.8281 28.9657V33.1036C24.8281 31.9606 25.754 31.0347 26.897 31.0347H31.0349V18.6208C31.0349 17.4778 31.9608 16.5519 33.1039 16.5519V8.27598C33.1039 7.13293 32.178 6.20703 31.0349 6.20703H24.828H16.552H10.3453C9.20227 6.20703 8.27637 7.13293 8.27637 8.27598V26.8968H16.5523H22.7591Z",
    fill: "#A0613F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.6548 53.7938H24.8271V33.1041C24.8271 31.9611 25.753 31.0352 26.8961 31.0352H47.5858C48.7289 31.0352 49.6548 31.9611 49.6548 33.1041V53.7938Z",
    fill: "#723C24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7587 26.8965H16.5517H8.27592H2.06895C0.9259 26.8965 0 27.8223 0 28.9654V53.7931H24.8276V28.9654C24.8276 27.8223 23.9017 26.8965 22.7587 26.8965Z",
    fill: "#CB8252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.207 49.6562H44.4828V43.4492H36.207V49.6562Z",
    fill: "#F9EBB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.3105 26.8964H47.5865V20.6895H39.3105V26.8964Z",
    fill: "#F9EBB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.20703 41.3794H18.6208V33.1035H6.20703V41.3794Z",
    fill: "#F9EBB0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.4824 20.6899H26.8962V12.4141H14.4824V20.6899Z",
    fill: "#F9EBB0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.6553 53.7927H60.0001V35.1719H49.6553V53.7927Z",
    fill: "#A0613F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2728_34159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPackagesBoxSvgrepoCom1);
export default __webpack_public_path__ + "static/media/business-packages-box-svgrepo-com 1.0934a6b7ff9fd63dee026602adf87d78.svg";
export { ForwardRef as ReactComponent };